import { IProduct } from "@Interfaces/Api/Product";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import { theme } from "@Definitions/Styled";
import dynamic from "next/dynamic";
const DesktopProductDetails = dynamic(() => import("./Desktop"));
const MobileProductDetails = dynamic(() => import("./Mobile"));
export interface IProductDetailProdps {
  product: IProduct;
}

export function ProductDetail({ product }: IProductDetailProdps) {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box>
      {!isMobile ? (
        <Box sx={{ display: { xs: "none", md: "flex" } }}>
          <DesktopProductDetails product={product} />
        </Box>
      ) : (
        <Box sx={{ display: { xs: "unset", md: "none" } }}>
          <MobileProductDetails product={product} />
        </Box>
      )}
    </Box>
  );
}
